




















































































import {
  Vue,
  Component,
} from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import DrdService from '@/domain/drd/service/drd.service';
import PerformanceDescriptionEntity from '@/domain/drd/entity/performance-description.entity';
import TabButton from '@/shared/tab-button.component.vue';
import IndicatorsComponent from '@/views/drd/form/tabs/indicators/indicators.component.vue';
import AreaKeyComponent from '@/views/drd/form/tabs/area-key/index.vue';
import BehavioralSkillComponent from '@/views/drd/form/tabs/behavioral-skill/index.vue';
import TechnicalKnowledgeComponent from '@/views/drd/form/tabs/technical-knowledge/index.vue';
import FormationComponent from '@/views/drd/form/tabs/formation/index.vue';
import AnalysisComponent from '@/views/drd/form/tabs/analysis/index.vue';
import Authority from '@/domain/security/authority.entity';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import Loading from '@/shared/loading/loading.component.vue';
import PerformanceDescriptionHeader from './performance-description-header.component.vue';
import TabComponent from '../commons/performance-description-tabs.component.vue';

@Component({
  components: {
    AreaKeyComponent,
    BehavioralSkillComponent,
    FormationComponent,
    PerformanceDescriptionHeader,
    IndicatorsComponent,
    TabComponent,
    TabButton,
    TechnicalKnowledgeComponent,
    AnalysisComponent,
    Loading,
  },
})
export default class PerformanceDescriptionComponent extends Vue {
  performanceDescriptionId: string = '';

  performanceDescription = PerformanceDescriptionEntity.of({});

  tab: number = 0;

  rootTab: boolean = false;

  loadingSave = false;

  authority: Authority = new Authority([]);

  hasUpdateDrd: boolean = false;

  hasDrdApproveProccess: boolean = false;

  loadingGetData: boolean = false;

  async created() {
    this.$destroy();
    this.performanceDescriptionId = this.$route.params.id;
    this.getPerformanceDescriptionData();
    await this.validationAuthority();
  }

  getPerformanceDescriptionData() {
    this.loadingGetData = true;
    DrdService.getPerformanceDescription(this.performanceDescriptionId)
      .then((resp: PerformanceDescriptionEntity) => {
        this.performanceDescription = resp;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingGetData = false);
  }

  saveAndNext(): void {
    if (this.tab === 0) {
      const { indicatorsComponent }: any = this.$refs;
      this.setLoading(true);
      indicatorsComponent.save()
        .finally(() => this.setLoading(false));
      return;
    }
    if (this.tab === 1) {
      const { areaKeyComponent }: any = this.$refs;
      this.setLoading(true);
      areaKeyComponent.save()
        .finally(() => this.setLoading(false));
      return;
    }
    if (this.tab === 2) {
      const { behavioralSkillComponent }: any = this.$refs;
      this.setLoading(true);
      behavioralSkillComponent.save()
        .finally(() => this.setLoading(false));
      return;
    }
    if (this.tab === 3) {
      const { technicalKnowledgeComponent }: any = this.$refs;
      this.setLoading(true);
      technicalKnowledgeComponent.save()
        .finally(() => this.setLoading(false));
      return;
    }
    if (this.tab === 4) {
      const { formationComponent }: any = this.$refs;
      this.setLoading(true);
      formationComponent.save()
        .finally(() => this.setLoading(false));
    }
    if (this.tab === 5) {
      this.setLoading(true);
      this.goToDrdList();
      this.setLoading(false);
    }
  }

  goToDrdList(): void {
    this.$router.push({
      path: '/performance-description-list',
    });
  }

  setLoading(value: boolean): void {
    this.loadingSave = value;
  }

  selectNextTab(): void {
    this.tab = this.tab + 1;
  }

  selectPreviousTab(): void {
    if (this.tab === 0) {
      this.$router.back();
      this.$destroy();
      return;
    }
    this.tab = this.tab - 1;
  }

  async validationAuthority() {
    await this.getAuthority();
    this.hasUpdateDrd = this.authority.hasUpdateDrds();
    this.hasDrdApproveProccess = this.authority.hasAuthorities([AuthorityEnum.DRD_APPROVE_PROCESS]);
  }

  async getAuthority() {
    await AuthorityStore.fetchedAuthority().then(authority => this.authority = authority);
  }

  get showApproveAndRejectBtns() {
    return this.hasDrdApproveProccess && (
      this.performanceDescription.isPendingApproval || this.performanceDescription.isDraft
    );
  }
}
